import { css } from 'styled-components';

export const gridBackground = () => {
  return css`
    background: url('../images/grid-square.svg') fixed;
  `;
};
